import { render, staticRenderFns } from "./PricelistDataEdition.vue?vue&type=template&id=38455bee&"
import script from "./PricelistDataEdition.vue?vue&type=script&lang=js&"
export * from "./PricelistDataEdition.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports